// GSAP animations for footer
const gsapFooterAnimations = () => {
	const footer = document.querySelector(".footer__wrapper");

	if (!footer) return;

	// Animate footer logo and left content
	const animateFooterLeft = () => {
		const leftContent = footer.querySelector(".footer__left");
		const logo = leftContent?.querySelector(".footer__logo");
		const infoGroups = leftContent?.querySelectorAll(".footer__info-group");

		if (leftContent) {
			// Set initial states
			if (logo) {
				gsap.set(logo, {
					opacity: 0,
					y: 30,
					scale: 0.9
				});
			}

			if (infoGroups.length > 0) {
				gsap.set(infoGroups, {
					opacity: 0,
					y: 20
				});
			}

			// Create scroll trigger for left content
			ScrollTrigger.create({
				trigger: leftContent,
				start: "top 90%",
				onEnter: () => {
					// Animate logo first
					if (logo) {
						gsap.to(logo, {
							opacity: 1,
							y: 0,
							scale: 1,
							duration: 0.8,
							ease: "power2.out"
						});
					}

					// Then animate info groups with stagger
					if (infoGroups.length > 0) {
						gsap.to(infoGroups, {
							opacity: 1,
							y: 0,
							duration: 0.6,
							stagger: 0.15,
							delay: 0.3,
							ease: "power2.out"
						});
					}
				}
			});
		}
	};

	// Animate footer menu columns
	const animateFooterMenus = () => {
		const menuColumns = footer.querySelectorAll(".footer__menu-column");

		if (menuColumns.length > 0) {
			gsap.set(menuColumns, {
				opacity: 0,
				y: 30
			});

			ScrollTrigger.batch(menuColumns, {
				start: "top 90%",
				onEnter: (elements) => {
					gsap.to(elements, {
						opacity: 1,
						y: 0,
						duration: 0.7,
						stagger: 0.2,
						ease: "power2.out"
					});
				}
			});
		}
	};

	// Animate social icons
	const animateFooterSocials = () => {
		const socialItems = footer.querySelectorAll(".footer__socials-item");

		if (socialItems.length > 0) {
			gsap.set(socialItems, {
				opacity: 0,
				y: 20,
				scale: 0.8
			});

			ScrollTrigger.create({
				trigger: footer.querySelector(".footer__socials"),
				start: "top 95%",
				onEnter: () => {
					gsap.to(socialItems, {
						opacity: 1,
						y: 0,
						scale: 1,
						duration: 0.5,
						stagger: 0.1,
						ease: "back.out(1.7)"
					});
				}
			});

			// Add hover effects for social icons
			socialItems.forEach(item => {
				const link = item.querySelector(".footer__socials-link");
				if (link) {
					link.addEventListener("mouseenter", () => {
						gsap.to(link, {
							scale: 1.1,
							duration: 0.3,
							ease: "power2.out"
						});
					});

					link.addEventListener("mouseleave", () => {
						gsap.to(link, {
							scale: 1,
							duration: 0.3,
							ease: "power2.out"
						});
					});
				}
			});
		}
	};

	// Animate footer bottom section
	const animateFooterBottom = () => {
		const footerBottom = footer.querySelector(".footer__bottom");
		const copyrightGroup = footerBottom?.querySelector(".footer__copywrite-group");
		const recaptcha = footerBottom?.querySelector(".footer__recaptcha");

		if (footerBottom) {
			const elements = [copyrightGroup, recaptcha].filter(Boolean);

			if (elements.length > 0) {
				gsap.set(elements, {
					opacity: 0,
					y: 20
				});

				ScrollTrigger.create({
					trigger: footerBottom,
					start: "top 95%",
					onEnter: () => {
						gsap.to(elements, {
							opacity: 1,
							y: 0,
							duration: 0.6,
							stagger: 0.2,
							ease: "power2.out"
						});
					}
				});
			}
		}
	};



	// Initialize all animations
	animateFooterLeft();
	animateFooterMenus();
	animateFooterSocials();
	animateFooterBottom();
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapFooterAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapFooterAnimations();
	});
}
